import type { ComponentChildren } from "preact";
import { useEffect } from "preact/hooks";
import { useHeaderContext } from "../contexts/HeaderContext";

/** Shows `actions()` in the mobile header while the calling page is mounted and `deps` are unchanged. */
export const useHeaderActions = (actions: () => ComponentChildren, deps: unknown[] = []): void => {
  const { setActions } = useHeaderContext();

  useEffect(() => {
    setActions(actions());
    return () => setActions(null);
  }, deps);
};
